//
// latLngToLocalMetres
//
// East/north metres of a point from a nearby origin (equirectangular), precise to a few
// centimetres over a building or a campus. Kept identical to the back end's shared copy
// (global/shared/src/utils/shared/geo/latLngToLocalMetres.js).
//

const EARTH_RADIUS_METRES = 6371008.8;
const RADIANS_PER_DEGREE = Math.PI / 180;

const latLngToLocalMetres = (origin, { lat, lng }) => {
  const metresPerDegree = RADIANS_PER_DEGREE * EARTH_RADIUS_METRES;
  return {
    east: (lng - origin.lng) * metresPerDegree * Math.cos(origin.lat * RADIANS_PER_DEGREE),
    north: (lat - origin.lat) * metresPerDegree,
  };
};

export default latLngToLocalMetres;
